import { Component, ViewEncapsulation } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { BrandingLogoComponent } from './branding-logo/branding-logo.component';
import { BrandingProductComponent } from './branding-product/branding-product.component';

@Component({
  selector: 'app-branding',
  standalone: true,
  imports: [
    FormsModule,
    NzSelectModule,
    NzUploadModule,
    BrandingLogoComponent,
    BrandingProductComponent,
  ],
  templateUrl: './branding.component.html',
  styleUrl: './branding.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class BrandingComponent {
  selectedValue = null;
}
